import { shade0, shade950 } from "../../../../styles/tokens";
import { IconProps } from "../../Checkbox.Parts";

export const ExcludedIcon = ({ type }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="currentColor" />
    <path
      d="M15.3246 6.8393L17.1607 8.67541C17.3302 8.84495 17.3296 9.11853 17.1607 9.28745L14.4481 12L17.1607 14.7125C17.3302 14.8821 17.3296 15.1557 17.1607 15.3246L15.3246 17.1607C15.1557 17.3296 14.8821 17.3302 14.7125 17.1607L12 14.4481L9.28745 17.1607C9.11853 17.3296 8.84495 17.3302 8.67542 17.1607L6.8393 15.3246C6.67038 15.1557 6.67038 14.8815 6.8393 14.7125L9.55185 12L6.8393 9.28745C6.67038 9.11853 6.67038 8.84434 6.8393 8.67541L8.67542 6.8393C8.84434 6.67038 9.11853 6.67038 9.28745 6.8393L12 9.55185L14.7126 6.8393C14.8815 6.67038 15.1557 6.67038 15.3246 6.8393Z"
      fill={type === "secondary" ? shade950 : shade0}
    />
  </svg>
);
